import {useMutation, UseMutationResult} from '@tanstack/react-query';
import {useLocale} from 'state/locale';
import Api from 'types/api';
import {request} from 'utils/request-axios';

import {SelectedReasonType} from './types';

export type BillingCancelRequest = {
    cancel: 'no' | 'yes';
    improvements: null | string;
    reason_detail: null | string;
    selected_reason: SelectedReasonType;
};

export type BillingCancelSuccessResponse =
    Api.Response.Success<BillingCancelRequest>;

export type BillingCancelErrorResponse = Api.Response.Failure<
    keyof BillingCancelRequest
>;

type UseBillingCancelProps = {
    partnerMid: string;
};

export const useBillingCancel = ({
    partnerMid,
}: UseBillingCancelProps): UseMutationResult<
    BillingCancelSuccessResponse,
    BillingCancelErrorResponse,
    Record<string, unknown>
> => {
    const locale = useLocale();

    return useMutation((formData) =>
        request({
            formData,
            locale,
            method: 'POST',
            url: `/api/partner/${partnerMid}/billing/cancel/`,
        }),
    );
};
